// extracted by mini-css-extract-plugin
export default {"modalBody":"ShowWarningModal_modalBody__ckq9W","modalTitle":"ShowWarningModal_modalTitle__d12Kj","actionBtns":"ShowWarningModal_actionBtns__WUCwL"};